module.exports = __webpack_public_path__ + "img/coop-icon4.118e6044.png";